module.exports = __webpack_public_path__ + "static/media/nab-honour.6a15ec89.jpg";